import { Module } from 'vuex'

interface Loader {
  size: number
  value?: boolean
  index?: number
}

interface CommonState {
  loader: Loader
}

const DEFAULT_LOADER: Loader = { size: 64, index: 10, value: false }

const commonStore: Module<CommonState, any> = {
  namespaced: true,
  state: () => ({
    loader: { ...DEFAULT_LOADER },
  }),
  mutations: {
    SET_LOADER(state, payload: Loader) {
      state.loader = payload
    },
  },
  actions: {
    showLoader({ commit }, payload: Loader) {
      commit('SET_LOADER', payload)
    },
    hideLoader({ commit }) {
      commit('SET_LOADER', { ...DEFAULT_LOADER })
    },
  },
}

export default commonStore